import * as React from "react";

const columns = (t) => [
    {
        label: t ? t("common.simulation_name") : "Nazwa symulacji",
        field: "name",
        sort: "desc",
        width: 53,
    },
    {
        label: t ? t("common.creation_date") : "Data utworzenia",
        field: "creationDate",
        sort: "desc",
        width: 53,
    },
    {
        label: t ? t("common.user") : "Użytkownik",
        field: "creationUsername",
        sort: "desc",
        width: 53,
    }
];

export default columns;